export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEKSEtkbGItQjUtSGEMoUsA6k4OAOsvAQDrMQABgQICAYEGAgGBCgIBgQ4CAYESAgGBFgIBgRoCAYEeaADqTw==", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/HKdlb-B5-V.bcmap
// module id = 657
// module chunks = 502